import React, { useEffect, useState } from 'react'
import './Navbar.css'
import { Link} from 'react-router-dom';
import {FaBars} from 'react-icons/fa';
import {AiOutlineHome} from 'react-icons/ai'

const logo = process.env.PUBLIC_URL + '/essel.svg';






const menuItems = [
    {
      heading: "About us",
      
      to : "/about"
    },
    {
      heading: "Area of Operation",
      
      to : '/#area'
    },
    {
      heading: "Projects",
      
      to : '/#project'
    },
    {
      heading: "Sustainability",
      to: "/sustainability"
      
    },
    {
      heading: "Clients",
      to:"/#clients"
    },
    {
      heading: "Contacts",
      to :"/#contact",
    },
    {
      heading: "Careers",
      to:"/career",
    },
  ];
  

function Header() {

  
  const [scrolled, setScrolled] = useState(false);
  const [showMenu, setShowMenu] = useState(false)

  useEffect(()=>{
    const handleScroll =()=>{
      const isScrolled = window.scrollY > 0;
      if (isScrolled !== scrolled){
        setScrolled(isScrolled)
      }
    };
    document.addEventListener('scroll', handleScroll);
    return ()=> {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  useEffect(()=>{
    const handleResize =()=>{
      if(window.innerWidth >768  ){
        setShowMenu(false)
      }
    };
    window.addEventListener('resize', handleResize);
    return()=>{
      window.addEventListener('resize', handleResize)
    }
  },[])

  const toggleMenu = ()=>{
    setShowMenu(!showMenu)
  }
  
  const scrollToTop =()=>{
    window.scrollTo({
        top:0,
        behavior:'smooth'
    })
}

const handleBothClick = ()=>{
  toggleMenu();
  scrollToTop();
}




  return (

    <>
   
    
    <nav className={scrolled? 'scrolled':''}>
    
        <div className="logo">
            <img src={logo} alt="" />
        </div>
        <div className="name">
            <h1>ESSEL PROJECTS PVT LTD</h1>
            <p>Built On Integrity . <span style={{color: '#e38835'}}>Driven By Performance</span></p>
        </div>
        <div className='fa-icon' onClick={toggleMenu}>
          <FaBars />
        </div>
        
        
        <ul className= {showMenu ? 'nav-links activemenu':'nav-links'}>
          <li >
            <Link to ={'/'} onClick={handleBothClick} className='home' ><AiOutlineHome/></Link>
          </li>
           {
            menuItems.map((menuItem, index)=>(
                <li  key={index} className='menulist'  >
                <Link  to={menuItem.to} onClick={handleBothClick} >{menuItem.heading}   </Link>
            </li>
            ))
           }
           
           
        </ul>
        
       


    </nav>

    </>
  )
}

export default Header